import { useEffect, useRef } from 'react';

/**
 * Header "Download ▾" disclosure. Native <details>/<summary> for the
 * click-to-toggle + keyboard support; CSS positions the panel as an
 * absolute popover under the summary so it floats over page content
 * rather than pushing it down.
 *
 * Click-outside-to-close is the one piece <details> doesn't give for
 * free — wired via a single mousedown listener on document.
 *
 * The full /download page still exists for deep details (file size,
 * install hints, browser-vs-APK comparison). The menu surfaces the
 * two everyday actions and a "more options" link to the full page.
 */
export function HeaderDownloadMenu() {
  const ref = useRef<HTMLDetailsElement | null>(null);

  useEffect(() => {
    const onDocClick = (e: MouseEvent) => {
      const el = ref.current;
      if (!el || !el.open) return;
      if (e.target instanceof Node && el.contains(e.target)) return;
      el.open = false;
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  // Close the menu after clicking one of the inner links so users
  // don't have to manually re-collapse it as they navigate.
  const closeOnNav = () => {
    if (ref.current) ref.current.open = false;
  };

  return (
    <details ref={ref} className="header-download-menu">
      <summary aria-label="Download options">Download</summary>
      <div className="header-download-menu-panel" role="menu">
        <a
          href="/joltstream.apk"
          download
          className="header-download-menu-item"
          role="menuitem"
          onClick={closeOnNav}
        >
          <strong>Android APK</strong>
          <span className="hint">Direct install (background recording)</span>
        </a>
        <a
          href="/download"
          className="header-download-menu-item"
          role="menuitem"
          onClick={closeOnNav}
        >
          <strong>All install options</strong>
          <span className="hint">iOS, browser path, install hints</span>
        </a>
      </div>
    </details>
  );
}
